<router-outlet></router-outlet>

<confirmation-modal></confirmation-modal>